export default __webpack_public_path__ + "static/media/team.73f24fb3.png";